import { render, staticRenderFns } from "./ChainList.vue?vue&type=template&id=929b3e3e"
import script from "./ChainList.vue?vue&type=script&lang=js"
export * from "./ChainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports